import React from "react";
import * as PropTypes from "prop-types";
import { css } from "@emotion/css";
import { withTranslation } from "react-i18next";
import Loading from "../components/Loading";
import RunHistoryTable from "../components/RunHistory/RunHistoryTable";

const classes = {
    mainContent: css`
        height: 100%;
        padding: 20px;
        overflow: auto;
    `,
};

const RunHistory = ({ t, ...rest }) => (
    <div className={classes.mainContent}>
        <Loading
            loading={rest.loadingData}
            message={t("Loading runs...")}
        >
            <RunHistoryTable {...rest} />
        </Loading>
    </div>
);

RunHistory.propTypes = {
    loadingData: PropTypes.bool,
    runs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            startedAt: PropTypes.instanceOf(Date).isRequired,
            completed: PropTypes.bool.isRequired,
        })
    ),
    notificationVariant: PropTypes.string,
    notificationOpen: PropTypes.bool,
    notificationMessage: PropTypes.string,
    onDownloadRunLog: PropTypes.func.isRequired,
    onCloseNotification: PropTypes.func.isRequired,
    onDeleteRun: PropTypes.func.isRequired,
};

RunHistory.defaultProps = {
    loadingData: false,
    runs: [],
    notificationOpen: false,
};

export default withTranslation()(RunHistory);
